import { useEffect, useRef } from "react";
import { captureException } from "@sentry/react";

interface Props<T> {
  key: string;
  data: T;
  onLoad: (data: T) => void;
}

export function useLocalStorage<T>({ key, data, onLoad }: Props<T>) {
  const loadedRef = useRef(false);

  useEffect(() => {
    try {
      const json = localStorage.getItem(key);
      if (json) onLoad(JSON.parse(json) as T);
    } catch (error) {
      captureException(error, { tags: { feature: "useLocalStorage.getItem" } });
    }
    loadedRef.current = true;
  }, []);

  useEffect(() => {
    if (!loadedRef.current) return;
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
      captureException(error, { tags: { feature: "useLocalStorage.setItem" } });
    }
  }, [data, key]);
}
